import { createModule } from 'saga-slice';
import { sagaApi } from '#/apis';
import { loadingReducer, failReducer } from 'saga-slice-helpers';
import { mapToId } from '#/meta';

const sagaSlice = createModule({

    name: 'renewals',
    initialState: {
        isFetching: false,
        data: {},
        error: null
    },

    reducers: {

        getRenewals: loadingReducer,
        getRenewalsSuccess: (state, payload) => {

            state.data = mapToId(payload);
            state.isFetching = false;
        },

        updateRenewal: loadingReducer,
        updateRenewalSuccess: (state, payload) => {
            state.data[payload.id] = payload;
            state.isFetching = false;
        },

        fail: failReducer
    },

    sagas: A => ({
        [A.getRenewals]: function* ({ payload }) {

            // yield sagaApi.get(`/properties/${property_id}/renewals`, A.getRenewalsSuccess, A.fail);
            yield sagaApi.post(
                `/properties/${payload.property_id}/renewals`,
                payload,
                A.getRenewalsSuccess,
                A.fail
            );
        },
        [A.updateRenewal]: function* ({ payload }) {
            const {
                id, property_id
            } = payload;
            delete payload.id;

            yield sagaApi.put(`/properties/${property_id}/renewals/${id}`, payload, A.updateRenewalSuccess, A.fail);
        }
    })
});

// Export actions for convenience when importing from other modules
export const { actions } = sagaSlice;
export default sagaSlice;
